// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/chunks/" + chunkId + ".d945b52a-2426-41a1-ad23-0230f1f35227.js";
};